module.exports = __webpack_public_path__ + "static/media/stijn-bessem-portfolio-digital-mountain-back-1440x400.34d3c48a.png";